import BoxItem from "@/app/core/layouts/main-components/delivery/BoxItem";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import React from "react";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function ResumeCard({ data, pricing }) {


    return (
        <div>
            <div className="block block-rounded block-bordered">
                <div className="block-header">
                    <div className="block-title"> <i className="far fa-bookmark mr-2 text-info"></i>{Translate(Message.Resume)}</div>
                </div>
                <div className="ml-1 mr-1 mb-1 mt-1">
                    <ul class="timeline timeline-alt mt-0 mb-0">
                        <li className="timeline-event">
                            <div class="media">
                                <div className="mr-5 overlay-container overlay-left">
                                    <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                        <i className="si si-map" />
                                    </span>
                                </div>
                                <div className="block-fx-pop media-body ml-5 mb-3">
                                    <div className="">
                                        <div className="block-title">
                                            {Translate(Message.Origin)} {" "}
                                            <b>{data && data.origin && `${data.origin.addressLine1}`}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-event">
                            <div class="media">
                                <div className="mr-5 overlay-container overlay-left">
                                    <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                        <i className="fa fa-flag-checkered" />
                                    </span>
                                </div>
                                <div className="block-fx-pop media-body ml-5 mb-3">
                                    <div className="">
                                        <div className="block-title">
                                            {Translate(Message.Destination)} {" "}
                                            <b>{data && data.destination && `${data.destination.addressLine1}`}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {pricing == undefined ?
                <div className="block block-rounded block-bordered">
                    <div className="block-header">
                        <div className="block-title"> <i className="fa fa-boxes text-success mr-2"></i>{Translate(Message.Boxes)}</div>
                    </div>
                    <div className="ml-1 mr-1 mb-1 mt-1">
                        {data && data.boxes && data.boxes.map((item, index) => (
                            <div className="col-12">
                                <BoxItem data={item} presentation={true} />
                            </div>
                        ))}
                    </div>
                </div>
                :
                ""
            }
        </div>
    )

}